import { useCallback } from "react";
import { GENERAL_SIDECOST_GROUPS_UI_ENABLED } from "../../constants/settingsFeatureFlags";
import { useAddressSystemPageAccess } from "../../hooks/useAddressSystemPageAccess";
import { useAddressSystemFeatures } from "../../hooks/useAddressSystemFeatures";
import { settingsLinks } from "./settingsLandingData";

export function useSettingsPageAccess() {
  const { hasUserDefaults } = useAddressSystemFeatures();
  const { visibleItems, isItemVisible } = useAddressSystemPageAccess(settingsLinks);

  // Override visibility for feature-flagged views
  const isViewVisible = useCallback(
    (viewId: string) => {
      // User defaults is controlled by FEATURE_USER_DEFAULTS
      if (viewId === "user-defaults") {
        return hasUserDefaults && isItemVisible(viewId);
      }
      // Hidden until go-live — see docs/GENERAL-SIDECOST-GROUPS-GO-LIVE.md
      if (viewId === "general-sidecost-groups" && !GENERAL_SIDECOST_GROUPS_UI_ENABLED) {
        return false;
      }
      return isItemVisible(viewId);
    },
    [hasUserDefaults, isItemVisible],
  );

  // Filter visible links for feature-flagged views
  const visibleLinks = visibleItems.filter((link) => {
    if (link.id === "user-defaults") {
      return hasUserDefaults;
    }
    if (link.id === "general-sidecost-groups" && !GENERAL_SIDECOST_GROUPS_UI_ENABLED) {
      return false;
    }
    return true;
  });

  return {
    visibleLinks,
    isViewVisible,
  };
}
